import React from 'react';
import { Box, TextField, Divider, FormControlLabel, Switch } from '@mui/material';
import SectionTitle from './SectionTitle';

export default function SecaoGeral({ parametros, handleChange }) {
    return (
        <Box>
            <SectionTitle descricao="Duração das sessões e janela de atendimento.">
                Agenda
            </SectionTitle>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 2 }}>
                <TextField fullWidth label="Duração padrão (min)"
                    name="duracaoPadraoSessaoMinutos" type="number"
                    value={parametros.duracaoPadraoSessaoMinutos} onChange={handleChange} />
                <TextField fullWidth label="Início do expediente"
                    name="horarioInicioExpediente" type="time"
                    InputLabelProps={{ shrink: true }} inputProps={{ step: 300 }}
                    value={parametros.horarioInicioExpediente} onChange={handleChange} />
                <TextField fullWidth label="Fim do expediente"
                    name="horarioFimExpediente" type="time"
                    InputLabelProps={{ shrink: true }} inputProps={{ step: 300 }}
                    value={parametros.horarioFimExpediente} onChange={handleChange} />
            </Box>

            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' }, gap: 2, mt: 2, alignItems: 'center' }}>
                <FormControlLabel
                    control={
                        <Switch
                            name="agendaGeracaoAutomatica"
                            checked={!!parametros.agendaGeracaoAutomatica}
                            onChange={handleChange}
                        />
                    }
                    label="Gerar agenda automaticamente"
                />
                <TextField fullWidth label="Janela de geração (dias)"
                    name="agendaJanelaDias" type="number"
                    value={parametros.agendaJanelaDias ?? 60}
                    onChange={handleChange}
                    inputProps={{ min: 1, max: 365 }}
                    helperText="Quantos dias à frente a agenda é gerada a partir das disponibilidades" />
            </Box>

            <Divider sx={{ my: 4 }} />

            <SectionTitle descricao="Lembrete enviado por e-mail ao paciente antes da consulta. Só vale para sessões agendadas e sai uma vez por sessão.">
                Lembrete de consulta
            </SectionTitle>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' }, gap: 2, alignItems: 'center' }}>
                <FormControlLabel
                    control={
                        <Switch
                            name="notificarSessaoPerto"
                            checked={!!parametros.notificarSessaoPerto}
                            onChange={handleChange}
                        />
                    }
                    label="Enviar lembrete de consulta"
                />
                <TextField fullWidth label="Antecedência (min)"
                    name="minutosAntecedenciaNotificacao" type="number"
                    value={parametros.minutosAntecedenciaNotificacao ?? 30}
                    onChange={handleChange}
                    disabled={!parametros.notificarSessaoPerto}
                    inputProps={{ min: 1, max: 1440 }}
                    helperText="Quantos minutos antes do horário da sessão o lembrete é enviado" />
            </Box>

            <Divider sx={{ my: 4 }} />

            <SectionTitle descricao="Valores padrão e regras de cobrança.">
                Financeiro
            </SectionTitle>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 2 }}>
                <TextField fullWidth label="Valor padrão da sessão (R$)"
                    name="valorPadraoSessao" type="number" inputProps={{ step: '0.01' }}
                    value={parametros.valorPadraoSessao} onChange={handleChange} />
                <TextField fullWidth label="Qtd. base de sessões/plano"
                    name="quantidadeBaseSessoes" type="number"
                    value={parametros.quantidadeBaseSessoes} onChange={handleChange}
                    helperText="Pré-preenche planos de atendimento" />
                <TextField fullWidth label="Dias de tolerância vencimento"
                    name="diasToleranciaVencimento" type="number"
                    value={parametros.diasToleranciaVencimento} onChange={handleChange} />
            </Box>

            <Divider sx={{ my: 4 }} />

            <SectionTitle descricao="Dias do mês em que o sistema gera links de renovação para assinaturas mensais com renovação manual. Separe por vírgula. Em branco desativa.">
                Renovação de assinaturas
            </SectionTitle>
            <Box sx={{ display: 'flex', gap: 2, maxWidth: 520 }}>
                <TextField fullWidth label="Dias de renovação"
                    name="diasRenovacao"
                    value={parametros.diasRenovacao}
                    onChange={handleChange}
                    placeholder="5,10,15,20" />
                <TextField label="Horário (hora)"
                    name="horarioRenovacao"
                    type="number"
                    value={parametros.horarioRenovacao ?? 8}
                    onChange={handleChange}
                    inputProps={{ min: 0, max: 23 }}
                    sx={{ minWidth: 140 }}
                    helperText="0–23h" />
            </Box>

            <Divider sx={{ my: 4 }} />

            <SectionTitle descricao="Esconde a barra lateral ao registrar evolução de sessão, dando foco total ao preenchimento. Um alerta avisa o psicólogo antes da entrada no modo.">
                Modo Foco
            </SectionTitle>
            <FormControlLabel
                control={
                    <Switch
                        name="modoFocoEvolucao"
                        checked={!!parametros.modoFocoEvolucao}
                        onChange={handleChange}
                    />
                }
                label="Ativar Modo Foco ao registrar evolução de prontuário"
            />
        </Box>
    );
}
